/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Treecount1Inputs */

const en_entity_treecount1 = /** @type {(inputs: Entity_Treecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tree Count`)
};

const de_entity_treecount1 = /** @type {(inputs: Entity_Treecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baumanzahl`)
};

/**
* | output |
* | --- |
* | "Tree Count" |
*
* @param {Entity_Treecount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_treecount1 = /** @type {((inputs?: Entity_Treecount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Treecount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_treecount1(inputs)
	return de_entity_treecount1(inputs)
});
export { entity_treecount1 as "entity_treeCount" }